export default function Subtitle ({ text, customCss }) {
  return (
    <p className={`text-gray-800 mb-4 mt-4 text-2xl font-semibold ${customCss}`}>
      {text}
    </p>
  )
}
